<template lang="pug">
.home
  aside.aside
    .nav
      .system-name(@click='$router.push("/")') 杭州湾大桥
        span 除湿数据采集与监视控制系统
      .nav-bar
        .nav-buttom
          router-link(to='/hangzhouwan/gasClamp') 全桥实时数据
          router-link(to='/hangzhouwan/ramp') 匝道除湿机
          router-link(to='/hangzhouwan/tower') 主塔除湿机
          router-link(to='/hangzhouwan/steelBox') 钢箱梁除湿机
          router-link(to='/hangzhouwan/ventilation') 新风/排风
          router-link.same-line(to='/hangzhouwan/bridgeImg') 
            p 全桥除湿
            p 总体布置图
          router-link(to='/hangzhouwan/dataHistory?bridgeId=af4efd47-4bf0-4ce4-b484-0003c5726b91&scenarioId=TBD') 数据历史

        //-   router-link(to='/sutong/airValve') 风阀遥控
        //-   router-link(to='/sutong/nantong') 南通侧除湿机
        //-   router-link(to='/sutong/changshu') 常熟侧除湿机
        //-   router-link(to='/sutong/ventilation') 排风

  TimeBlock.time-block(bridgeName='HANGZHOU')
</template>

<script>
import TimeBlock from "@/components/TimeBlock";

export default {
  name: "Index",
  components: {
    TimeBlock,
  },
  data() {
    return {
      timer: null,
      bridgeId: "af4efd47-4bf0-4ce4-b484-0003c5726b91",
      historyScenarioList: [],
    };
  },
  computed: {},
  mounted() {
    this.timer = setInterval(() => {
      this.checkAuth();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    checkAuth() {
      this.$http.get("/auth/LoginInfo").then((res) => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  height: 100%;
  position: relative;
  background: url("../../assets/image/hangzhouwan/hangzhouwan.jpg") center no-repeat;
  background-size: cover;

  .time-block {
    position: absolute;
    top: 100px;
    right: 150px;
  }

  .aside {
    position: relative;
    width: 250px;
    height: 100%;
    color: #fff;
    min-width: 260px;
    text-align: center;
    box-shadow: 0 0 30px 0 #000;
    overflow: hidden;
    box-sizing: border-box;
    background: url("../../assets/image/hangzhouwan/hangzhouwan1.jpg") center no-repeat fixed;
    background-size: cover;

    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
      background: transparent;
    }

    ::-webkit-scrollbar-corner {
      background: transparent;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background-color: #84a4c2;
    }

    ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
      border-radius: 0;
      background-color: transparent;
    }

    .nav {
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      right: 0;
      z-index: 1;

      a {
        display: block;
        width: 58%;
        height: 48px;
        margin: 0 auto 20px auto;
        border: none;
        line-height: 48px;
        border-radius: 5px;
        color: #4b4e50;
        background: #cadce9;
        cursor: pointer;
        text-decoration: none;

        &.same-line {
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 18px;
        }

        p {
          margin: 0;
        }

        &:hover {
          color: #fff;
          background: #33a2f5;
        }
      }

      .system-name {
        height: 75px;
        font-weight: 700;
        font-size: 40px;
        margin: 75px 0;
        cursor: pointer;
        span {
          display: block;
          font-size: 18px;
        }
      }

      .nav-bar {
        height: calc(100% - 250px);
        overflow-y: auto;
      }
    }
  }
}
</style>
